import React, {
  useState,
  useRef,
  useEffect,
  useCallback,
  useMemo,
} from "react";
import "../../Dashborad/dashboard.css";
import {
  Box,
  TextField,
  Typography,
  IconButton,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
  Paper,
  Grid,
  FormControl,
  InputLabel,
  Select,
  TablePagination,
  CircularProgress,
  Collapse,
  Button,
  Stack,
  Tabs,
  Tab,
  Tooltip,
  Drawer,
  Divider,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import CloseIcon from "@mui/icons-material/Close";
import FilterListIcon from "@mui/icons-material/FilterList";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import CloudUploadOutlinedIcon from "@mui/icons-material/CloudUploadOutlined";
import MilitaryTechOutlinedIcon from "@mui/icons-material/MilitaryTechOutlined";
import TableChartOutlinedIcon from "@mui/icons-material/TableChartOutlined";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import {
  adminAllConsultation,
  adminConsultationsQuery,
  adminUpdateAppointmentById,
  generatePartnersXmlMeetingReport,
  getAllDocuments,
  getMriDocuments,
} from "../../../config/service";
import { downloadConsultationsCsvFromServer } from "./meetingDetailsCsvExport";
import ViewDocument from "./ViewDocument";
import ConsultationsAdminCommentsModal from "./ConsultationsAdminCommentsModal";
import ConsultationsMeetingUpdate from "./ConsultationsMeetingUpdate";
import ConsultationsOfferDateModal from "./ConsultationsOfferDateModal";
import ProfileDetails from "./ProfileDetails";
import ConsultationsMeetingLogModal from "./ConsultationsMeetingLogModal";
import Report from "./Report";
import MyDoctorUpload from "./myDoctorUpload";
import AdminIdfModal from "./AdminIDFModal";
import { STATUS_TYPES } from "./meetingDetailsConstants";
import { mapMeetingToRow } from "./meetingDetailsUtils";
import ConsultationsTable from "./ConsultationsTable";
import ConsultationsHelpDiagram from "./ConsultationsHelpDiagram";

/** Top-row letters → status tab index (q=All, w=Scheduled, e=Created, …). */
const STATUS_FILTER_KEY_LETTERS = "qwertyui";

const LANG = () => localStorage.getItem("lang") || "EN";

export default function AdminConsultations() {
  const { t } = useTranslation();
  const anchorRef = useRef(null);
  const searchInputRef = useRef(null);
  const [menuAnchor, setMenuAnchor] = useState(null);
  const [helpDrawerOpen, setHelpDrawerOpen] = useState(false);
  const [filtersOpen, setFiltersOpen] = useState(false);

  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [sortField, setSortField] = useState("createdAt");
  const [sortDir, setSortDir] = useState(-1);
  const [globalSearchInput, setGlobalSearchInput] = useState("");
  const [globalSearch, setGlobalSearch] = useState("");
  const [statusFilter, setStatusFilter] = useState([]);
  const [createdFrom, setCreatedFrom] = useState("");
  const [createdTo, setCreatedTo] = useState("");
  const [scheduledFrom, setScheduledFrom] = useState("");
  const [scheduledTo, setScheduledTo] = useState("");
  const [createdDateRange, setCreatedDateRange] = useState("any");
  const [scheduledDateRange, setScheduledDateRange] = useState("any");
  const [clientNameContains, setClientNameContains] = useState("");
  const [physicianNameContains, setPhysicianNameContains] = useState("");

  const [rows, setRows] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [loading, setLoading] = useState(true);

  const lang = LANG();

  const allMeetingData = useMemo(
    () =>
      STATUS_TYPES.map((type) => ({
        type,
        meetings: rows
          .filter((r) => r.MeetingStatus === type)
          .map((r) => ({ data: r.data })),
      })),
    [rows]
  );

  const skipFilterPageReset = useRef(true);

  const [id, setId] = useState();
  const [clientId, setClientId] = useState();
  const [document, setDocument] = useState([]);
  const [documentModal, setDocumentModal] = useState(false);
  const [documentEntryMode, setDocumentEntryMode] = useState("view_or_upload");
  const [offerModal, setOfferModal] = useState(false);
  const [offerMeetingId, setoffermeetingId] = useState();
  const [newOfferDate, setDates] = useState([]);
  const [consultId, setConsultID] = useState();
  const [mstatus, setMStatus] = useState();
  const [doctorId, setDoctorId] = useState();
  const [assapValue, setAsapValue] = useState();
  const [fdate, setFDate] = useState();
  const [sdate, setSDate] = useState();
  const [ftime, setFTime] = useState();
  const [stime, setSTime] = useState();
  const [startDate, setStartDate] = useState(new Date());
  const [startDate1, setStartDate1] = useState(new Date());
  const [comentmeetingid, setCommentMeetingId] = useState();
  const [comment, setComment] = useState();
  const [commentModal, setCommentModal] = useState(false);
  const [consultData, setConsultData] = useState([]);
  const [consultfilter, setConsultfilter] = useState([]);
  const [updateId, setUpdateId] = useState();
  const [updateData, setUpdateData] = useState([]);
  const [pacseeDocument, setPacseeDocument] = useState([]);
  const [updateModal, setUpdateModal] = useState(false);
  const [priceModal, setPriceModal] = useState(false);
  const [offerDates, setOfferDates] = useState([]);
  const [offerData, setofferdata] = useState([]);
  const [reqdates, setReqDates] = useState([]);
  const [reportModal, setReportModal] = useState(false);
  const [meetinglogId, setMeetinglogId] = useState();
  const [meetinglogmodal, setMeetinglogmodal] = useState(false);
  const [detailsopen, setDetailsOpen] = useState(false);
  const [role, setRole] = useState();
  const [userid, setUserID] = useState();
  const [meetingType, setMeetingType] = useState("");
  const [idfModal, setIdfModal] = useState(false);
  const [myDoctorModal, setMyDoctorModal] = useState(false);

  const statusOptions = useMemo(
    () => STATUS_TYPES.map((type) => ({ type })),
    []
  );
  const statusTabs = useMemo(() => ["ALL", ...STATUS_TYPES], []);
  const statusTabValue = useMemo(() => {
    if (statusFilter.length === 0) return "ALL";
    if (statusFilter.length === 1 && STATUS_TYPES.includes(statusFilter[0])) {
      return statusFilter[0];
    }
    return "ALL";
  }, [statusFilter]);

  const statusFilterShortcutsTooltip = useMemo(
    () => (
      <Box
        component="span"
        sx={{
          display: "block",
          textAlign: "start",
          maxWidth: 320,
          py: 0.25,
        }}
      >
        <Typography variant="caption" component="span" sx={{ lineHeight: 1.5,
          display: "block",
        }}>
          {statusTabs
            .map((tabValue, i) => {
              const k = STATUS_FILTER_KEY_LETTERS[i]?.toUpperCase() ?? "?";
              const label = tabValue === "ALL" ? t("All") : tabValue;
              return `${k} ${label}`;
            })
            .join(" · ")}
        </Typography>
        <Typography
          variant="caption"
          component="span"
          sx={{ display: "block", mt: 0.75, opacity: 0.92, lineHeight: 1.45 }}
        >
          {t("Status tab arrows hint")}
        </Typography>
      </Box>
    ),
    [statusTabs, t]
  );

  const buildFilters = useCallback(() => {
    const filters = {};
    if (statusFilter.length > 0) filters.statuses = statusFilter;
    if (createdFrom) filters.createdAtFrom = new Date(createdFrom).toISOString();
    if (createdTo) filters.createdAtTo = new Date(createdTo).toISOString();
    if (scheduledFrom)
      filters.scheduledDateFrom = new Date(scheduledFrom).toISOString();
    if (scheduledTo)
      filters.scheduledDateTo = new Date(scheduledTo).toISOString();
    if (clientNameContains.trim())
      filters.clientNameContains = clientNameContains.trim();
    if (physicianNameContains.trim())
      filters.physicianNameContains = physicianNameContains.trim();
    return Object.keys(filters).length ? filters : undefined;
  }, [
    statusFilter,
    createdFrom,
    createdTo,
    scheduledFrom,
    scheduledTo,
    clientNameContains,
    physicianNameContains,
  ]);

  const loadData = useCallback(async () => {
    setLoading(true);
    try {
      const body = {
        page,
        perPage,
        sortField,
        sortDir,
        globalSearch: globalSearch.trim() || undefined,
        filters: buildFilters(),
      };
      const response = await adminConsultationsQuery(body);
      const raw = response?.data?.result ?? [];
      const mapped = raw
        .map((d) => mapMeetingToRow(d, lang))
        .filter(Boolean);
      setRows(mapped);
      setTotalCount(response?.data?.totalCount ?? 0);
    } catch (e) {
      console.error(e);
      toast.error(t("Failed to load consultations"));
    } finally {
      setLoading(false);
    }
  }, [
    page,
    perPage,
    sortField,
    sortDir,
    globalSearch,
    buildFilters,
    lang,
    t,
  ]);

  useEffect(() => {
    const tmr = setTimeout(() => setGlobalSearch(globalSearchInput), 400);
    return () => clearTimeout(tmr);
  }, [globalSearchInput]);

  useEffect(() => {
    const toInputDate = (d) => {
      const dt = new Date(d);
      const y = dt.getFullYear();
      const m = `${dt.getMonth() + 1}`.padStart(2, "0");
      const day = `${dt.getDate()}`.padStart(2, "0");
      return `${y}-${m}-${day}`;
    };

    const now = new Date();
    if (createdDateRange === "any") {
      setCreatedFrom("");
      setCreatedTo("");
      return;
    }
    if (createdDateRange === "today") {
      const day = toInputDate(now);
      setCreatedFrom(day);
      setCreatedTo(day);
      return;
    }
    if (createdDateRange === "last7") {
      const from = new Date(now);
      from.setDate(now.getDate() - 6);
      setCreatedFrom(toInputDate(from));
      setCreatedTo(toInputDate(now));
      return;
    }
    if (createdDateRange === "month") {
      const first = new Date(now.getFullYear(), now.getMonth(), 1);
      setCreatedFrom(toInputDate(first));
      setCreatedTo(toInputDate(now));
    }
  }, [createdDateRange]);

  useEffect(() => {
    const toInputDate = (d) => {
      const dt = new Date(d);
      const y = dt.getFullYear();
      const m = `${dt.getMonth() + 1}`.padStart(2, "0");
      const day = `${dt.getDate()}`.padStart(2, "0");
      return `${y}-${m}-${day}`;
    };

    const now = new Date();
    if (scheduledDateRange === "any") {
      setScheduledFrom("");
      setScheduledTo("");
      return;
    }
    if (scheduledDateRange === "today") {
      const day = toInputDate(now);
      setScheduledFrom(day);
      setScheduledTo(day);
      return;
    }
    if (scheduledDateRange === "last7") {
      const from = new Date(now);
      from.setDate(now.getDate() - 6);
      setScheduledFrom(toInputDate(from));
      setScheduledTo(toInputDate(now));
      return;
    }
    if (scheduledDateRange === "month") {
      const first = new Date(now.getFullYear(), now.getMonth(), 1);
      setScheduledFrom(toInputDate(first));
      setScheduledTo(toInputDate(now));
    }
  }, [scheduledDateRange]);

  useEffect(() => {
    const onSlashFocus = (e) => {
      const tag = e.target?.tagName?.toLowerCase();
      const isTyping =
        tag === "input" || tag === "textarea" || e.target?.isContentEditable;
      if (e.key === "/" && !isTyping) {
        e.preventDefault();
        searchInputRef.current?.focus();
      }
    };
    window.addEventListener("keydown", onSlashFocus);
    return () => window.removeEventListener("keydown", onSlashFocus);
  }, []);

  const handleStatusQuickChange = useCallback((nextValue) => {
    if (nextValue === "ALL") {
      setStatusFilter([]);
      return;
    }
    if (STATUS_TYPES.includes(nextValue)) {
      setStatusFilter([nextValue]);
    }
  }, []);

  useEffect(() => {
    const shouldIgnoreTarget = (el) => {
      const tag = el?.tagName?.toLowerCase();
      if (
        tag === "input" ||
        tag === "textarea" ||
        tag === "select" ||
        el?.isContentEditable
      ) {
        return true;
      }
      if (
        el?.closest?.('[role="dialog"]') ||
        el?.closest?.("[aria-modal=\"true\"]")
      ) {
        return true;
      }
      if (el?.closest?.('[role="menu"]') || el?.closest?.('[role="listbox"]')) {
        return true;
      }
      return false;
    };

    const onStatusKeyboardShortcuts = (event) => {
      const el = event.target;
      if (shouldIgnoreTarget(el)) return;

      if (event.ctrlKey || event.metaKey || event.altKey) return;
      const ch = event.key.length === 1 ? event.key.toLowerCase() : "";
      const letterIndex = STATUS_FILTER_KEY_LETTERS.indexOf(ch);
      if (letterIndex === -1) return;
      if (letterIndex >= statusTabs.length) return;
      event.preventDefault();
      handleStatusQuickChange(statusTabs[letterIndex]);
    };
    window.addEventListener("keydown", onStatusKeyboardShortcuts);
    return () =>
      window.removeEventListener("keydown", onStatusKeyboardShortcuts);
  }, [statusTabs, handleStatusQuickChange]);

  useEffect(() => {
    loadData();
  }, [loadData]);

  useEffect(() => {
    if (skipFilterPageReset.current) {
      skipFilterPageReset.current = false;
      return;
    }
    setPage(1);
  }, [
    globalSearch,
    statusFilter,
    createdFrom,
    createdTo,
    scheduledFrom,
    scheduledTo,
    clientNameContains,
    physicianNameContains,
  ]);

  const consultingFields = async () => {
    try {
      const response = await adminAllConsultation();
      setConsultData(response.data.result);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    consultingFields();
  }, []);

  const handleCloseModal = () => {
    setOfferModal(false);
    loadData();
    setSDate();
    setFDate();
    setFTime();
    setSTime();
    setStartDate();
    setStartDate1();
    setDates([]);
    setConsultID();
  };

  const handleCloseComment = () => {
    setCommentModal(false);
    loadData();
  };

  const handleClose = () => {
    setUpdateModal(false);
    loadData();
  };

  const handleDetailsClose = () => {
    setDetailsOpen(false);
    setUserID();
  };

  const openClientProfile = useCallback((meetingData) => {
    const id = meetingData?.clientData?._id;
    if (!id) return;
    setRole("client");
    setUserID(id);
    setDetailsOpen(true);
  }, []);

  const openDoctorProfile = useCallback((meetingData) => {
    const doctorId =
      meetingData?.doctorData?._id ||
      (meetingData?.offerDates?.[0]?.DoctorId
        ? meetingData.offerDates[0].DoctorId
        : null);
    if (!doctorId) return;
    setRole("doctor");
    setUserID(doctorId);
    setDetailsOpen(true);
  }, []);

  const handleMeetingLogModal = () => setMeetinglogmodal(false);
  const handleReportModalClose = () => setReportModal(false);

  const view = (mid, id2, data, offerdata) => {
    const c = consultData.filter((d) => d._id == id2);
    setConsultfilter(c);
    setUpdateId(mid);
    setUpdateData(data);
    setofferdata(offerdata);
    setDoctorId(
      data?.DoctorId
        ? data.DoctorId
        : data?.offerDates &&
          data.offerDates.length != 0 &&
          data?.statuses !== "Scheduled"
        ? data.offerDates[0].DoctorId
        : ""
    );
    setUpdateModal(true);
  };

  const openModal = (
    mid,
    dates,
    cid,
    offerdate,
    meetingstatus,
    requesteddates,
    asapvalue
  ) => {
    setoffermeetingId(mid);
    setDates(dates);
    setOfferDates(offerdate);
    setConsultID(cid);
    setMStatus(meetingstatus);
    setReqDates(requesteddates);
    setAsapValue(asapvalue);
    setOfferModal(true);
  };

  const asssonpossible = (
    mid,
    cid,
    offerdate,
    meetingstatus,
    requesteddates,
    asapvalue
  ) => {
    setoffermeetingId(mid);
    setOfferDates(offerdate);
    setConsultID(cid);
    setMStatus(meetingstatus);
    setReqDates(requesteddates);
    setOfferModal(true);
    setAsapValue(asapvalue);
  };

  const viewComment = (mid, data) => {
    setCommentMeetingId(mid);
    setComment(data);
    setCommentModal(true);
  };

  const allDocument = async (mid) => {
    try {
      const response = await getAllDocuments(mid);
      if ([200, 201, 202].includes(response.data.code)) {
        setDocument(response.data.meetingDocuments);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const viewDocument = async (
    mid,
    id2,
    data,
    entryMode = "view_or_upload"
  ) => {
    setDocumentEntryMode(entryMode);
    setMeetingType(data?.meetingType);
    setId(mid);
    setClientId(id2);
    setDocumentModal(true);
    allDocument(mid);
    try {
      const response = await getMriDocuments(mid);
      setPacseeDocument(response.data.pacseeFiles);
    } catch (error) {
      console.log(error);
    }
  };

  const handleChangestatus = (event, mid) => {
    const targetValue = event.target.value;
    statusUpload(targetValue, mid);
  };

  const statusUpload = async (targetValue, mid) => {
    setRows((prev) => prev.filter((r) => r["Meeting Id"] !== mid));

    const data = {
      statuses: targetValue,
      meetingIds: [mid],
    };
    try {
      const response = await adminUpdateAppointmentById(data);
      if ([200, 201, 202].includes(response.status)) {
        toast.success(response.data.msg);
      }
      loadData();
    } catch (error) {
      console.log(error);
      loadData();
    }
  };

  const meetinglog = (mid) => {
    setMeetinglogId(mid);
    setMeetinglogmodal(true);
  };

  const UpdateDetails = async (checkedValue, meetingid) => {
    const data = {
      isNotification: checkedValue,
      meetingIds: [meetingid],
    };
    try {
      const response = await adminUpdateAppointmentById(data);
      if ([200, 201, 202].includes(response.status)) {
        toast.success(t(response.data.msg));
        loadData();
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleSortChange = (field) => {
    if (sortField === field) {
      setSortDir((d) => (d === 1 ? -1 : 1));
    } else {
      setSortField(field);
      setSortDir(-1);
    }
    setPage(1);
  };

  const downloadXmlFile = (xmlData, outputFilename) => {
    const blob = new Blob([xmlData], { type: "text/xml" });
    const url = window.URL.createObjectURL(blob);
    anchorRef.current.href = url;
    anchorRef.current.setAttribute("download", outputFilename);
    anchorRef.current.click();
    window.URL.revokeObjectURL(url);
  };

  const handleGeneratePartnersXmlReport = async (meetingId) => {
    const data = { meetingId };
    try {
      const response = await generatePartnersXmlMeetingReport(data);
      if (response.status === 201) {
        if (response.data.message) {
          toast.error(t(response.data.message));
        } else {
          const outputFilename = `${meetingId}-Ichilov.xml`;
          downloadXmlFile(response.data, outputFilename);
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleExportCsv = async () => {
    try {
      await downloadConsultationsCsvFromServer({
        sortField,
        sortDir,
        globalSearch: globalSearch.trim() || undefined,
        filters: buildFilters(),
        maxRows: 5000,
        lang: lang === "HE" ? "HE" : "EN",
      });
      toast.success(t("Export started"));
    } catch (e) {
      console.error(e);
      toast.error(t("Export failed"));
    }
    setMenuAnchor(null);
  };

  const priceClose = () => {
    setPriceModal(false);
    loadData();
  };

  return (
    <>
      <a ref={anchorRef} style={{ display: "none" }} />
      <ProfileDetails
        detailsopen={detailsopen}
        role={role}
        userid={userid}
        handleDetailsClose={handleDetailsClose}
        consultationsGlass
      />
      <ConsultationsOfferDateModal
        offerModal={offerModal}
        offerMeetingId={offerMeetingId}
        handleCloseModal={handleCloseModal}
        newOfferDate={newOfferDate}
        fdate={fdate}
        setFDate={setFDate}
        sdate={sdate}
        setSDate={setSDate}
        ftime={ftime}
        setFTime={setFTime}
        stime={stime}
        setSTime={setSTime}
        startDate={startDate}
        setStartDate={setStartDate}
        startDate1={startDate1}
        setStartDate1={setStartDate1}
        consultId={consultId}
        offerDates={offerDates}
        mstatus={mstatus}
        requestedDates={reqdates}
        assapValue={assapValue}
        AllApoinmentDoctor={() => loadData()}
      />
      <ConsultationsMeetingLogModal
        open={meetinglogmodal}
        onClose={handleMeetingLogModal}
        meetingId={meetinglogId}
        lang={lang}
      />
      <ConsultationsAdminCommentsModal
        open={commentModal}
        onClose={handleCloseComment}
        meetingId={comentmeetingid}
        initialComment={comment}
        lang={lang}
      />
      {id && documentModal && (
        <ViewDocument
          documentModal={documentModal}
          document={document}
          entryMode={documentEntryMode}
          setDocumentModal={setDocumentModal}
          meetingid={id}
          clientId={clientId}
          pacseeDocument={pacseeDocument}
          setPacseeDocument={setPacseeDocument}
          meetingType={meetingType}
        />
      )}
      <ConsultationsMeetingUpdate
        consultfilter={consultfilter}
        updateId={updateId}
        updateData={updateData}
        updateModal={updateModal}
        setUpdateModal={setUpdateModal}
        handleClose={handleClose}
        consultData={consultData}
        priceClose={priceClose}
        priceModal={priceModal}
        setPriceModal={setPriceModal}
        offerDates={offerData}
        doctorId={doctorId}
        setDoctorId={setDoctorId}
        refetchAllmeetings={loadData}
        allMeetingData={allMeetingData}
        setUpdateData={setUpdateData}
      />
      <Report
        handleReportModalClose={handleReportModalClose}
        reportModal={reportModal}
      />
      {idfModal && (
        <AdminIdfModal
          idfModal={idfModal}
          handleIdfUpload={() => setIdfModal(false)}
          getallmeetings={loadData}
        />
      )}
      {myDoctorModal && (
        <MyDoctorUpload
          myDoctorModal={myDoctorModal}
          setMyDoctorModal={setMyDoctorModal}
          handleMyDoctorUpload={() => setMyDoctorModal(false)}
        />
      )}

      <Box
        className="adminDataTable"
        dir="ltr"
        sx={{
          direction: "ltr",
          px: { xs: 1, sm: 2, md: 3 },
          py: 2,
          bgcolor: "grey.50",
          minHeight: "100vh",
        }}
      >
        <Paper
          elevation={0}
          sx={{
            p: 2.25,
            mb: 2,
            borderRadius: "14px",
            border: "1px solid rgba(255,255,255,0.55)",
            background:
              "linear-gradient(180deg, rgba(255,255,255,0.78), rgba(248,250,252,0.62))",
            backdropFilter: "blur(14px)",
            WebkitBackdropFilter: "blur(14px)",
            boxShadow:
              "0 10px 30px rgba(15,23,42,0.10), inset 0 1px 0 rgba(255,255,255,0.5)",
          }}
        >
          <Box
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            gap={1.5}
          >
            <Box>
              <Typography variant="h5" component="h1" fontWeight={600}>
                {t("Consultations")}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                {t("Server-filtered meeting list")}
              </Typography>
            </Box>
            <Stack direction="row" alignItems="center" spacing={0.25}>
              <Tooltip title={t("Consultations help open")}>
                <IconButton
                  aria-label={t("Consultations help open")}
                  onClick={() => setHelpDrawerOpen(true)}
                  edge="end"
                  size="large"
                >
                  <HelpOutlineIcon />
                </IconButton>
              </Tooltip>
              <Tooltip title={t("More actions menu")}>
                <IconButton
                  aria-label={t("More actions menu")}
                  onClick={(e) => setMenuAnchor(e.currentTarget)}
                  edge="end"
                  size="large"
                >
                  <MenuIcon />
                </IconButton>
              </Tooltip>
            </Stack>
            <Menu
              dir="ltr"
              anchorEl={menuAnchor}
              open={Boolean(menuAnchor)}
              onClose={() => setMenuAnchor(null)}
              anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
              transformOrigin={{ vertical: "top", horizontal: "right" }}
            >
              <MenuItem
                onClick={() => {
                  setReportModal(true);
                  setMenuAnchor(null);
                }}
              >
                <ListItemIcon sx={{ minWidth: 40, color: "primary.main" }}>
                  <FileDownloadOutlinedIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText primary={t("Download report")} />
              </MenuItem>
              <MenuItem
                onClick={() => {
                  setMyDoctorModal(true);
                  setMenuAnchor(null);
                }}
              >
                <ListItemIcon sx={{ minWidth: 40, color: "secondary.main" }}>
                  <CloudUploadOutlinedIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText primary={t("myDoctor Upload")} />
              </MenuItem>
              <MenuItem
                onClick={() => {
                  setIdfModal(true);
                  setMenuAnchor(null);
                }}
              >
                <ListItemIcon sx={{ minWidth: 40, color: "text.secondary" }}>
                  <MilitaryTechOutlinedIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText primary="IDF" />
              </MenuItem>
              <MenuItem onClick={handleExportCsv}>
                <ListItemIcon sx={{ minWidth: 40, color: "success.main" }}>
                  <TableChartOutlinedIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText primary={t("Export to CSV")} />
              </MenuItem>
            </Menu>

            <Drawer
              anchor="right"
              open={helpDrawerOpen}
              onClose={() => setHelpDrawerOpen(false)}
              PaperProps={{
                sx: {
                  width: { xs: "100%", sm: 420 },
                  maxWidth: "100vw",
                  borderTopLeftRadius: 16,
                  borderBottomLeftRadius: 16,
                  bgcolor: "rgba(255,255,255,0.98)",
                  backdropFilter: "blur(12px)",
                },
              }}
            >
              <Box
                sx={{
                  p: 2,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  gap: 1,
                  borderBottom: "1px solid",
                  borderColor: "divider",
                }}
              >
                <Typography variant="h6" component="h2" fontWeight={700}>
                  {t("Consultations help title")}
                </Typography>
                <IconButton
                  aria-label={t("Close")}
                  onClick={() => setHelpDrawerOpen(false)}
                  size="small"
                >
                  <CloseIcon />
                </IconButton>
              </Box>
              <Box
                sx={{
                  p: 2.5,
                  overflow: "auto",
                  maxHeight: "calc(100vh - 64px)",
                }}
              >
                <Typography variant="body2" color="text.secondary" paragraph>
                  {t("Consultations help intro")}
                </Typography>

                <ConsultationsHelpDiagram t={t} />

                <Typography variant="subtitle2" fontWeight={700} sx={{ mt: 2, mb: 1 }}>
                  {t("Consultations help section table")}
                </Typography>
                <Box component="ul" sx={{ m: 0, pl: 2.25, "& li": { mb: 0.75 } }}>
                  <Typography component="li" variant="body2">
                    {t("Consultations help row click")}
                  </Typography>
                  <Typography component="li" variant="body2">
                    {t("Consultations help paging")}
                  </Typography>
                  <Typography component="li" variant="body2">
                    {t("Consultations help row keys")}
                  </Typography>
                  <Typography component="li" variant="body2">
                    {t("Consultations help digit keys")}
                  </Typography>
                  <Typography component="li" variant="body2">
                    {t("Consultations help action keys")}
                  </Typography>
                  <Typography component="li" variant="body2">
                    {t("Consultations help status menu keys")}
                  </Typography>
                </Box>

                <Typography variant="subtitle2" fontWeight={700} sx={{ mt: 2.5, mb: 1 }}>
                  {t("Consultations help section filters")}
                </Typography>
                <Box component="ul" sx={{ m: 0, pl: 2.25, "& li": { mb: 0.75 } }}>
                  <Typography component="li" variant="body2">
                    {t("Consultations help status tab keys")}
                  </Typography>
                  <Typography component="li" variant="body2">
                    {t("Consultations help search slash")}
                  </Typography>
                  <Typography component="li" variant="body2">
                    {t("Consultations help date filters")}
                  </Typography>
                  <Typography component="li" variant="body2">
                    {t("Consultations help more filters")}
                  </Typography>
                </Box>

                <Typography variant="subtitle2" fontWeight={700} sx={{ mt: 2.5, mb: 1 }}>
                  {t("Consultations help section menu")}
                </Typography>
                <Box component="ul" sx={{ m: 0, pl: 2.25, "& li": { mb: 0.75 } }}>
                  <Typography component="li" variant="body2">
                    {t("Consultations help hamburger")}
                  </Typography>
                  <Typography component="li" variant="body2">
                    {t("Consultations help sort")}
                  </Typography>
                  <Typography component="li" variant="body2">
                    {t("Consultations help status pill")}
                  </Typography>
                </Box>

                <Divider sx={{ my: 2 }} />
                <Typography variant="caption" color="text.secondary" display="block">
                  {t("Status tab arrows hint")}
                </Typography>
              </Box>
            </Drawer>
          </Box>

          <Stack
            direction={{ xs: "column", md: "row" }}
            spacing={1.25}
            sx={{ mt: 1.5 }}
            alignItems={{ xs: "stretch", md: "center" }}
          >
            <TextField
              inputRef={searchInputRef}
              size="small"
              placeholder={`${t("Search")} (/ )`}
              value={globalSearchInput}
              onChange={(e) => setGlobalSearchInput(e.target.value)}
              sx={{
                minWidth: 280,
                flex: { xs: "unset", md: 1 },
                "& .MuiOutlinedInput-root": {
                  borderRadius: "12px",
                  bgcolor: "rgba(255,255,255,0.5)",
                  backdropFilter: "blur(8px)",
                  transition: "all 180ms ease",
                  "& fieldset": {
                    borderColor: "rgba(148,163,184,0.28)",
                  },
                  "&:hover fieldset": {
                    borderColor: "rgba(56,189,248,0.45)",
                  },
                  "&.Mui-focused": {
                    boxShadow: "0 0 0 3px rgba(14,165,233,0.14)",
                  },
                },
              }}
              type="search"
              inputProps={{ "aria-label": t("Search consultations") }}
            />
            <Tooltip
              title={statusFilterShortcutsTooltip}
              enterDelay={300}
              placement="top-start"
              slotProps={{
                tooltip: {
                  sx: {
                    bgcolor: "rgba(30, 41, 59, 0.92)",
                    maxWidth: 360,
                    px: 1.5,
                    py: 1.25,
                    borderRadius: "10px",
                    border: "1px solid rgba(148, 163, 184, 0.22)",
                    boxShadow: "0 12px 28px rgba(15,23,42,0.2)",
                  },
                },
              }}
            >
              <Box
                sx={{
                  minWidth: 290,
                  borderRadius: "12px",
                  border: "1px solid rgba(148,163,184,0.28)",
                  bgcolor: "rgba(255,255,255,0.5)",
                  backdropFilter: "blur(8px)",
                  px: 0.5,
                }}
              >
                <Tabs
                  value={statusTabValue}
                  onChange={(_, v) => handleStatusQuickChange(v)}
                  aria-label="Status tabs"
                  variant="scrollable"
                  scrollButtons="auto"
                  TabIndicatorProps={{ style: { height: 2 } }}
                  sx={{ minHeight: 40 }}
                >
                  <Tab
                    value="ALL"
                    label={t("All")}
                    sx={{ minHeight: 40, textTransform: "none", px: 1.25 }}
                  />
                  {STATUS_TYPES.map((s) => (
                    <Tab
                      key={s}
                      value={s}
                      label={s}
                      sx={{ minHeight: 40, textTransform: "none", px: 1.25 }}
                    />
                  ))}
                </Tabs>
              </Box>
            </Tooltip>
            <FormControl size="small" sx={{ minWidth: 190 }}>
              <InputLabel id="date-created-quick-label">{t("Date created")}</InputLabel>
              <Select
                labelId="date-created-quick-label"
                label={t("Date created")}
                value={createdDateRange}
                onChange={(e) => setCreatedDateRange(e.target.value)}
                MenuProps={{ PaperProps: { sx: { direction: "ltr" } } }}
                sx={{
                  borderRadius: "12px",
                  bgcolor: "rgba(255,255,255,0.5)",
                  backdropFilter: "blur(8px)",
                  "& fieldset": { borderColor: "rgba(148,163,184,0.28)" },
                  "&:hover fieldset": { borderColor: "rgba(56,189,248,0.45)" },
                }}
              >
                <MenuItem value="any">{t("Any time")}</MenuItem>
                <MenuItem value="today">{t("Today")}</MenuItem>
                <MenuItem value="last7">{t("Last 7 days")}</MenuItem>
                <MenuItem value="month">{t("This month")}</MenuItem>
              </Select>
            </FormControl>
            <FormControl size="small" sx={{ minWidth: 190 }}>
              <InputLabel id="date-scheduled-quick-label">{t("Date scheduled")}</InputLabel>
              <Select
                labelId="date-scheduled-quick-label"
                label={t("Date scheduled")}
                value={scheduledDateRange}
                onChange={(e) => setScheduledDateRange(e.target.value)}
                MenuProps={{ PaperProps: { sx: { direction: "ltr" } } }}
                sx={{
                  borderRadius: "12px",
                  bgcolor: "rgba(255,255,255,0.5)",
                  backdropFilter: "blur(8px)",
                  "& fieldset": { borderColor: "rgba(148,163,184,0.28)" },
                  "&:hover fieldset": { borderColor: "rgba(56,189,248,0.45)" },
                }}
              >
                <MenuItem value="any">{t("Any time")}</MenuItem>
                <MenuItem value="today">{t("Today")}</MenuItem>
                <MenuItem value="last7">{t("Last 7 days")}</MenuItem>
                <MenuItem value="month">{t("This month")}</MenuItem>
              </Select>
            </FormControl>
            <Button
              size="small"
              variant="outlined"
              startIcon={<FilterListIcon />}
              onClick={() => setFiltersOpen((o) => !o)}
              sx={{
                minWidth: 138,
                textTransform: "none",
                borderRadius: "12px",
                bgcolor: "rgba(255,255,255,0.48)",
                borderColor: "rgba(148,163,184,0.32)",
                color: "text.primary",
                "&:hover": {
                  borderColor: "rgba(56,189,248,0.45)",
                  bgcolor: "rgba(255,255,255,0.68)",
                  boxShadow: "0 6px 16px rgba(15,23,42,0.10)",
                },
              }}
            >
              {filtersOpen ? t("Hide filters") : t("More filters")}
            </Button>
          </Stack>

          <Collapse in={filtersOpen}>
            <Grid
              container
              spacing={2}
              sx={{
                mt: 1.25,
                p: 1.25,
                borderRadius: "12px",
                bgcolor: "rgba(255,255,255,0.45)",
                border: "1px solid rgba(255,255,255,0.5)",
              }}
            >
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  size="small"
                  label={t("Created from")}
                  type="date"
                  InputLabelProps={{ shrink: true }}
                  value={createdFrom}
                  onChange={(e) => setCreatedFrom(e.target.value)}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  size="small"
                  label={t("Created to")}
                  type="date"
                  InputLabelProps={{ shrink: true }}
                  value={createdTo}
                  onChange={(e) => setCreatedTo(e.target.value)}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  size="small"
                  label={t("Scheduled from")}
                  type="date"
                  InputLabelProps={{ shrink: true }}
                  value={scheduledFrom}
                  onChange={(e) => setScheduledFrom(e.target.value)}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  size="small"
                  label={t("Scheduled to")}
                  type="date"
                  InputLabelProps={{ shrink: true }}
                  value={scheduledTo}
                  onChange={(e) => setScheduledTo(e.target.value)}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  size="small"
                  label={t("Client name contains")}
                  value={clientNameContains}
                  onChange={(e) => setClientNameContains(e.target.value)}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  size="small"
                  label={t("Physician name contains")}
                  value={physicianNameContains}
                  onChange={(e) => setPhysicianNameContains(e.target.value)}
                />
              </Grid>
            </Grid>
          </Collapse>
        </Paper>

        <Box position="relative">
          {loading && rows.length > 0 && (
            <Box
              position="absolute"
              top={0}
              left={0}
              right={0}
              bottom={0}
              display="flex"
              alignItems="center"
              justifyContent="center"
              bgcolor="rgba(255,255,255,0.6)"
              zIndex={2}
            >
              <CircularProgress size={32} />
            </Box>
          )}
          <ConsultationsTable
            rows={rows}
            page={page}
            totalPages={Math.max(1, Math.ceil((totalCount || 0) / perPage))}
            onPageChange={setPage}
            loading={loading}
            statusFilter={statusFilter}
            statusOptions={statusOptions}
            sortField={sortField}
            sortDir={sortDir}
            onSortChange={handleSortChange}
            view={view}
            viewDocument={viewDocument}
            viewComment={viewComment}
            openModal={openModal}
            asssonpossible={asssonpossible}
            UpdateDetails={UpdateDetails}
            meetinglog={meetinglog}
            handleChangestatus={handleChangestatus}
            handleGeneratePartnersXmlReport={handleGeneratePartnersXmlReport}
            openClientProfile={openClientProfile}
            openDoctorProfile={openDoctorProfile}
          />
        </Box>

        <TablePagination
          component="div"
          count={totalCount}
          page={page - 1}
          onPageChange={(e, newPage) => setPage(newPage + 1)}
          rowsPerPage={perPage}
          onRowsPerPageChange={(e) => {
            setPerPage(parseInt(e.target.value, 10));
            setPage(1);
          }}
          rowsPerPageOptions={[10]}
          sx={{ mt: 1 }}
        />
      </Box>
    </>
  );
}
